'use strict';

var log = require('../../log/Log').channel('DimmerControlsExtension');
var sutl = require('../../sutl/Sutl');

var DimmerControlsExtension = function($scope, $ionicPopover, $timeout, 
                                       $window, $ionicPosition,
                                       IosTouchEventService) {
    log.info('initializing');

    var vm = this;
    var dimmerControlsPopover = null;
    var dimmerControlsRoom = null;
    var dimmerControlId = null;
    var dimmerReleasePromise;
    var dimmerStateUnwatch = null;
    var incrementDimmer = 0;
    var saveDimmer = null;
    var wrappedDimmerHandlers = IosTouchEventService.wrapHandlers(
        incrementDimmerTouch, incrementDimmerRelease);

    vm.dimmercontrols = {};
    vm.dimmercontrols.isDimmerHeld = false;
    vm.dimmercontrols.isUserChangingDimmer = false;
    vm.dimmercontrols.showDimmerControls = showDimmerControls;
    vm.dimmercontrols.hideDimmerControls = hideDimmerControls;
    vm.dimmercontrols.incrementDimmerTouch = wrappedDimmerHandlers.onTouch;
    vm.dimmercontrols.incrementDimmerRelease = wrappedDimmerHandlers.onRelease;
    vm.dimmercontrols.dimmer = 0;
    vm.dimmercontrols.areDimmerControlsVisible = areDimmerControlsVisible;
    vm.dimmercontrols.sliderOptions = {
        floor: 0,
        ceil: 100,
        vertical: true,
        hidePointerLabels: true,
        hideLimitLabels: true,
        showSelectionBar: true,
        disableAnimation: true,
        onStart: onDimmerHold,
        onChange: onDimmerChanged,
        onEnd: onDimmerRelease,
        interval: 10
    };
    vm.dimmercontrols.sliderHidden = true;

    $scope.$on('popover.hidden', function($event, popover) {
        if (popover === dimmerControlsPopover) {
            popover.remove();
        }
    });

    $scope.$on('popover.removed', function($event, popover) {
        if (popover === dimmerControlsPopover) {
            if (dimmerStateUnwatch) {
                dimmerStateUnwatch();
                dimmerStateUnwatch = null;
            }
            dimmerControlsRoom = null;
            dimmerControlId = null;
            dimmerControlsPopover = null;
            vm.dimmercontrols.sliderHidden = true;
        }
    });

    function areDimmerControlsVisible(id) { 
        return dimmerControlId === id;
    }

    function hideDimmerControls() {
        if (dimmerControlsPopover !== null) {
            return dimmerControlsPopover.remove();
        }
        return null;
    }

    function showDimmerControls(room, controlId, $event) {
        var hiding = hideDimmerControls();
        if (!hiding) {
            show();
        }
        else {
            hiding.then(show);
        }

        function show() {
            $ionicPopover.fromTemplateUrl('lightingDimmerControl.html', {
                scope: $scope,
                // HACK/undocumented: positionView overrides an internal 
                // positioning function, due to being combined via an internal 
                // .extend()
                positionView: positionDimmerControlsView
            }).then(function(popover) {
                dimmerControlsPopover = popover;
                dimmerControlsRoom = room;
                dimmerControlId = controlId;
                dimmerStateUnwatch = 
                    $scope.$watch(function() {
                                    var dimmer = sutl.getNode(
                                        room, 'states.lightingControls.' + controlId + '.level');
                                    return dimmer !== null ? dimmer : 0; 
                                  }, 
                                  onDimmerStateChanged);                        
                dimmerControlsPopover.show($event).then(function() {
                    vm.dimmercontrols.sliderHidden = false;
                });
            });
        }
    }

    function positionDimmerControlsView(target, popoverEle) {
        // Adapted from $ionicPopover source
        var POPOVER_BODY_PADDING = 6;
        var targetEle = angular.element(target.target || target);
        var buttonOffset = $ionicPosition.offset(targetEle);
        var popoverWidth = popoverEle.prop('offsetWidth');
        var popoverHeight = popoverEle.prop('offsetHeight');
        // Use innerWidth and innerHeight, because clientWidth and clientHeight
        // doesn't work consistently for body on all platforms
        var bodyWidth = $window.innerWidth;
        var bodyHeight = $window.innerHeight;

        var popoverCSS = {
            left: buttonOffset.left + buttonOffset.width / 2 - popoverWidth / 2
        };
        var arrowEle = angular.element(popoverEle[0].querySelector('.arrow-left'));

        if (popoverCSS.left < POPOVER_BODY_PADDING) {
            popoverCSS.left = POPOVER_BODY_PADDING;
        } else if (popoverCSS.left + popoverWidth + POPOVER_BODY_PADDING > bodyWidth) {
            popoverCSS.left = bodyWidth - popoverWidth - POPOVER_BODY_PADDING;
        }

        // If the popover when popped down stretches past bottom of screen,
        // adjust it to fit.
        if (buttonOffset.top + popoverHeight > bodyHeight &&
            buttonOffset.top - popoverHeight > 0) {
            popoverCSS.top = bodyHeight - popoverHeight;
        } else {
            popoverCSS.top = buttonOffset.top;
        }

        arrowEle.css({
            top: buttonOffset.top + buttonOffset.height / 2 -
                 arrowEle.prop('offsetHeight') / 2 - popoverCSS.top + 'px'
        });

        popoverEle.css({
            top: popoverCSS.top + 'px',
            left: popoverCSS.left + 'px',
            marginLeft: '0',
            opacity: '1'
        });
    }

    function onDimmerStateChanged(newValue, oldValue) {
        if (vm.dimmercontrols.isUserChangingDimmer) {
            saveDimmer = newValue;
            scheduleVolumeRelease();
        } else {
            vm.dimmercontrols.dimmer = newValue;
       }
    }

    function incrementDimmerTouch($event, increment) {
        if (!angular.isDefined(increment)) {
            increment = 1;
        }
        if (!vm.dimmercontrols.isIncrementVolumeHeld) {
            incrementDimmer = vm.dimmercontrols.dimmer;
        }
        incrementDimmer = Math.max(vm.dimmercontrols.sliderOptions.floor, 
                             Math.min(vm.dimmercontrols.sliderOptions.ceil, 
                                      incrementDimmer + increment));
        vm.dimmercontrols.isIncrementVolumeHeld = true;
        vm.dimmercontrols.isUserChangingDimmer = true;
        saveDimmer = null;
        vm.dimmercontrols.dimmer = incrementDimmer;
        setDimmer(incrementDimmer);
    }

    function incrementDimmerRelease($event) {
        vm.dimmercontrols.isIncrementVolumeHeld = false;
        scheduleVolumeRelease();
    }

    function setDimmer(newValue) {
        if (dimmerControlsRoom !== null && dimmerControlId !== null) {
            dimmerControlsRoom.$requestLightingLevel(dimmerControlId, newValue);
        }
    }

    function onDimmerChanged(sliderId, value) {
        if (vm.dimmercontrols.isDimmerHeld) {
            setDimmer(value);
        }
    }

    function onDimmerHold() {
        vm.dimmercontrols.isDimmerHeld = true;
        vm.dimmercontrols.isUserChangingDimmer = true;
        saveDimmer = null;
    }

    function releaseVolume() {
        if (!vm.dimmercontrols.isDimmerHeld) {
            vm.dimmercontrols.isUserChangingDimmer = false;
            if (saveDimmer !== null) {
                vm.dimmercontrols.dimmer = saveDimmer;
            }
        }
    }

    function scheduleVolumeRelease() {
        $timeout.cancel(dimmerReleasePromise);
        dimmerReleasePromise = $timeout(releaseVolume, 300);
    }

    function onDimmerRelease() {
        vm.dimmercontrols.isDimmerHeld = false;
        scheduleVolumeRelease();
    }
};

module.exports = DimmerControlsExtension;
